/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdResponse,
    LiveStreamCreateGiveawayItemRequest,
    LiveStreamCreateGiveawayWinnerRequest,
} from '../models';

export interface LiveStreamGiveawayItemApiControllerCancelGiveawayItemRequest {
    liveStreamId: string;
    giveawayItemId: string;
}

export interface LiveStreamGiveawayItemApiControllerCheckEntrantEligibilityRequest {
    liveStreamId: string;
    giveawayItemId: string;
    entrantId: string;
}

export interface LiveStreamGiveawayItemApiControllerCreateGiveawayEntrantRequest {
    liveStreamId: string;
    giveawayItemId: string;
}

export interface LiveStreamGiveawayItemApiControllerCreateGiveawayItemRequest {
    liveStreamId: string;
    liveStreamCreateGiveawayItemRequest: LiveStreamCreateGiveawayItemRequest;
}

export interface LiveStreamGiveawayItemApiControllerCreateGiveawayWinnerRequest {
    liveStreamId: string;
    giveawayItemId: string;
    liveStreamCreateGiveawayWinnerRequest: LiveStreamCreateGiveawayWinnerRequest;
}

export interface LiveStreamGiveawayItemApiControllerRemoveGiveawayItemRequest {
    liveStreamId: string;
    giveawayItemId: string;
}

/**
 * 
 */
export class LiveStreamGiveawayItemApi extends runtime.BaseAPI {

    /**
     */
    async liveStreamGiveawayItemApiControllerCancelGiveawayItemRaw(requestParameters: LiveStreamGiveawayItemApiControllerCancelGiveawayItemRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamGiveawayItemApiControllerCancelGiveawayItem.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling liveStreamGiveawayItemApiControllerCancelGiveawayItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/giveaway-items/{giveawayItemId}:cancel`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCancelGiveawayItem(requestParameters: LiveStreamGiveawayItemApiControllerCancelGiveawayItemRequest): Promise<void> {
        await this.liveStreamGiveawayItemApiControllerCancelGiveawayItemRaw(requestParameters);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCheckEntrantEligibilityRaw(requestParameters: LiveStreamGiveawayItemApiControllerCheckEntrantEligibilityRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamGiveawayItemApiControllerCheckEntrantEligibility.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling liveStreamGiveawayItemApiControllerCheckEntrantEligibility.');
        }

        if (requestParameters.entrantId === null || requestParameters.entrantId === undefined) {
            throw new runtime.RequiredError('entrantId','Required parameter requestParameters.entrantId was null or undefined when calling liveStreamGiveawayItemApiControllerCheckEntrantEligibility.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/giveaway-items/{giveawayItemId}/entrants/{entrantId}:checkEligibility`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))).replace(`{${"entrantId"}}`, encodeURIComponent(String(requestParameters.entrantId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCheckEntrantEligibility(requestParameters: LiveStreamGiveawayItemApiControllerCheckEntrantEligibilityRequest): Promise<void> {
        await this.liveStreamGiveawayItemApiControllerCheckEntrantEligibilityRaw(requestParameters);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCreateGiveawayEntrantRaw(requestParameters: LiveStreamGiveawayItemApiControllerCreateGiveawayEntrantRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamGiveawayItemApiControllerCreateGiveawayEntrant.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling liveStreamGiveawayItemApiControllerCreateGiveawayEntrant.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/giveaway-items/{giveawayItemId}/entrants`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCreateGiveawayEntrant(requestParameters: LiveStreamGiveawayItemApiControllerCreateGiveawayEntrantRequest): Promise<void> {
        await this.liveStreamGiveawayItemApiControllerCreateGiveawayEntrantRaw(requestParameters);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCreateGiveawayItemRaw(requestParameters: LiveStreamGiveawayItemApiControllerCreateGiveawayItemRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamGiveawayItemApiControllerCreateGiveawayItem.');
        }

        if (requestParameters.liveStreamCreateGiveawayItemRequest === null || requestParameters.liveStreamCreateGiveawayItemRequest === undefined) {
            throw new runtime.RequiredError('liveStreamCreateGiveawayItemRequest','Required parameter requestParameters.liveStreamCreateGiveawayItemRequest was null or undefined when calling liveStreamGiveawayItemApiControllerCreateGiveawayItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/giveaway-items`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.liveStreamCreateGiveawayItemRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCreateGiveawayItem(requestParameters: LiveStreamGiveawayItemApiControllerCreateGiveawayItemRequest): Promise<IdResponse> {
        const response = await this.liveStreamGiveawayItemApiControllerCreateGiveawayItemRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCreateGiveawayWinnerRaw(requestParameters: LiveStreamGiveawayItemApiControllerCreateGiveawayWinnerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamGiveawayItemApiControllerCreateGiveawayWinner.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling liveStreamGiveawayItemApiControllerCreateGiveawayWinner.');
        }

        if (requestParameters.liveStreamCreateGiveawayWinnerRequest === null || requestParameters.liveStreamCreateGiveawayWinnerRequest === undefined) {
            throw new runtime.RequiredError('liveStreamCreateGiveawayWinnerRequest','Required parameter requestParameters.liveStreamCreateGiveawayWinnerRequest was null or undefined when calling liveStreamGiveawayItemApiControllerCreateGiveawayWinner.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/giveaway-items/{giveawayItemId}:createWinner`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.liveStreamCreateGiveawayWinnerRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerCreateGiveawayWinner(requestParameters: LiveStreamGiveawayItemApiControllerCreateGiveawayWinnerRequest): Promise<void> {
        await this.liveStreamGiveawayItemApiControllerCreateGiveawayWinnerRaw(requestParameters);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerRemoveGiveawayItemRaw(requestParameters: LiveStreamGiveawayItemApiControllerRemoveGiveawayItemRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling liveStreamGiveawayItemApiControllerRemoveGiveawayItem.');
        }

        if (requestParameters.giveawayItemId === null || requestParameters.giveawayItemId === undefined) {
            throw new runtime.RequiredError('giveawayItemId','Required parameter requestParameters.giveawayItemId was null or undefined when calling liveStreamGiveawayItemApiControllerRemoveGiveawayItem.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/giveaway-items/{giveawayItemId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"giveawayItemId"}}`, encodeURIComponent(String(requestParameters.giveawayItemId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async liveStreamGiveawayItemApiControllerRemoveGiveawayItem(requestParameters: LiveStreamGiveawayItemApiControllerRemoveGiveawayItemRequest): Promise<void> {
        await this.liveStreamGiveawayItemApiControllerRemoveGiveawayItemRaw(requestParameters);
    }

}
